import {html} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import {FlywheelComponent} from '#lit/lib/component.js';
import styles from './style.scss';
import {styleMap} from 'lit/directives/style-map.js';
import {classMap} from 'lit/directives/class-map.js';
import {multiplyPixelString} from '#lit/utils/strings.js';

// Constants
export const BAR_LOADER_ELEMENT_TAG = 'fly-bar-loader';
export const BAR_LOADER_DEFAULT_WIDTH = '250px';
export const BAR_LOADER_DEFAULT_HEIGHT = '24px';

// Enums
export enum LoaderVariants {
  BAR = 'bar',
  SQUARE = 'square',
  CIRCLE = 'circle',
}

/**
 * Animated bar loader
 */
@customElement(BAR_LOADER_ELEMENT_TAG)
export default class FlyBarLoader extends FlywheelComponent {
  @property({type: String})
  variant: LoaderVariants = LoaderVariants.BAR;

  @property({type: String})
  width = BAR_LOADER_DEFAULT_WIDTH;

  @property({type: String})
  height = BAR_LOADER_DEFAULT_HEIGHT;

  @property({type: Boolean})
  animated = false;

  static get styles() {
    return [styles];
  }

  get classes(): unknown {
    return classMap({
      'fly-loader--animated': this.animated,
      'fly-loader--circle': this.variant === LoaderVariants.CIRCLE,
    });
  }

  get borderRadius(): string {
    return this.variant === LoaderVariants.CIRCLE
      ? multiplyPixelString(this.width, 2)
      : 'inherit';
  }

  beforeLoad() {
    if (this.variant !== LoaderVariants.BAR) {
      if (this.height !== this.width) {
        console.warn(
          'Note: square and circle variants only use the width prop.'
        );
      }

      this.height = this.width;
    }
  }

  render() {
    const styles = {
      '--fly-loader-width': this.width,
      '--fly-loader-height': this.height,
      '--fly-loader-radius': this.borderRadius,
    };
    return html`
      <div style=${styleMap(styles)} class="fly-loader ${this.classes}"></div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'fly-bar-loader': FlyBarLoader;
  }
}
